// Types
import Dictionary from '@/types/dictionary';
import { InvestmentRiskLevel } from '../types/risk-profiles';

// Utils
import { LOCALE } from './i18n';
import LocalizedString from '@/types/localized-string';
import RiskRating from '@/types/risk-rating';

/**
 * Formats a risk rating string (localized) to 100% allocations format. ie: 'Low' => { LOW: 100 }
 * @param riskRating Risk rating string literals to format.
 */
export const riskRatingLiteralToAllocations = (riskRating?: LocalizedString): RiskRating | undefined => {
  const riskMap: Dictionary<InvestmentRiskLevel> = {
    'Very Low': InvestmentRiskLevel.VeryLow,
    Low: InvestmentRiskLevel.Low,
    'Low to medium': InvestmentRiskLevel.LowMedium,
    Medium: InvestmentRiskLevel.Medium,
    'Medium to high': InvestmentRiskLevel.MediumHigh,
    High: InvestmentRiskLevel.High,
    'Very high': InvestmentRiskLevel.VeryHigh,
  };

  if (!riskRating || !riskRating[LOCALE.EN_CA] || !riskMap[riskRating[LOCALE.EN_CA] as string]) {
    return undefined;
  }

  const key = riskMap[riskRating[LOCALE.EN_CA] as string];

  return {
    [key]: 100,
  };
};
